<template>
    <div class="animated fadeIn">     
        <b-card>
            <div slot="header">Detail Transaction GL by Dimension 
                <div class="card-header-actions">
                <button class="btn btn-primary mr-1"  @click="process()"> <i class="fa fa-play"></i> Process</button>
                <button class="btn btn-primary mr-1" @click="print()">
                    <i class="fa fa-print"></i>
                    print
                </button>
                <button class="btn btn-primary mr-1" @click="exportxls()">
                    <i class="fa fa-file-excel-o"></i>
                    Export
                </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
               <b-col xl="5">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2 mr-2">Dimension</span></b-input-group-prepend>
                        <b-form-select v-model="model.DimCol" :plain="true" :options="dimension" :state="!$v.model.DimCol.$error"></b-form-select>
                        <b-form-input readonly v-model="model.DimValInfo" placeholder="Dimension Value" :state="!$v.model.DimVal.$error" class="ml-1" style="width:40% !important;"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuDimShow=true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                  </b-input-group>
               </b-col>
               <b-col xl="7">
                  <b-input-group >
                      <b-input-group-prepend><span class="pt-2 mr-2">Gl Account</span></b-input-group-prepend>
                      <b-form-input readonly v-model="model.kodeawinfo" :state="!$v.model.kodeaw.$error" style="width:25% !important;"></b-form-input>
                      <b-input-group-append>
                        <b-btn text="Button" @click="showLkuCoa('kodeaw')">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                        <b-input-group-prepend><span class="pt-2 mr-2">Trx. Date</span></b-input-group-prepend>
                        <b-form-input v-model="model.tgl1" type="date" placeholder="from date"  @change="updateTgl2" :state="!$v.model.tgl2.$error" class="mr-1"></b-form-input>
                        <b-form-input v-model="model.tgl2" type="date" placeholder="until date" @change="updateTgl1" :state="!$v.model.tgl2.$error"></b-form-input>
                    </b-input-group>
               </b-col>
            </b-row>  
      <b-card no-body>
            <b-table
                class="mb-0"
                ref="tableOri"
                sticky-header="600px" outlined responsive striped hover
                style="font-size:smaller;"
                :items="rptLines"
                :fields="tblLcy.fields"
                :current-page="tblLcy.page"
                :per-page="tblLcy.limit"
                :sort-by.sync="tblLcy.sortBy"
                :sort-desc.sync="tblLcy.sortDesc"
                :filter="filterInput"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
            >
              <template v-slot:cell(tanggal)="data">
                  {{ data.item.tanggal | moment("DD-MMM-YYYY") }}
                  <!-- <span v-if="(data.item.tanggal)">{{ data.item.tanggal | moment("DD-MMM-YYYY") }}</span> -->
              </template>
                <template v-slot:cell(nomor)="data">
                        <span v-if="(data.item.nomor=='BEGINING')">{{data.item.nomor}}</span>
                        <span v-else ><b-link @click.stop="printJv(data.item)">{{data.item.nomor}}</b-link></span>
                </template>

                <template v-slot:cell(umasuk)="data">
                      {{ data.item.umasuk | numFormat }}
                </template>
                <template v-slot:cell(ukeluar)="data">
                      {{ data.item.ukeluar | numFormat }}
                </template>
                <template v-slot:cell(sakhir)="data">
                      {{ data.item.sakhir | numFormat }}
                </template>
            </b-table>

        <b-row class="m-1">
          <b-col lg="6">            
            <b-row v-if="(filterShow=='Hide')">
                  <b-input-group size="sm">
                      <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                        <b-input-group-prepend> <span class="pr-2">
                            <b> {{ filterShow }}</b>  Filter </span>
                        </b-input-group-prepend>
                      <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                          <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                  </b-input-group>
                  <b-input-group size="sm" class="ml-4">
                      <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                      </b-input-group-prepend>
                      <b-form-checkbox-group v-model="filterOn" class="mt-1">
                        <b-form-checkbox value="nomor">Voucher Number</b-form-checkbox>
                        <b-form-checkbox value="uraian">Description</b-form-checkbox>
                        <b-form-checkbox value="umasuk">Debit Amount</b-form-checkbox>
                        <b-form-checkbox value="ukeluar">Credit Amount</b-form-checkbox>
                      </b-form-checkbox-group>
                  </b-input-group>
                  <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
            </b-row>
            <b-row v-else>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch >
                <b> {{ filterShow }}</b>  Filter
              </b-form-checkbox>
            </b-row>
          </b-col>
          <b-col lg="6">
            <div style="display: flex;margin:0;padding:0;">
                <div style="margin:0;padding:5px;width:500px; text-align:right;">
                    Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
                    to <span v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)">{{tblLcy.total}}</span> <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
                    of {{tblLcy.total}} ,   <span class="mr-1">limit per page :</span> 
                    <select  v-model="tblLcy.limit"  style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>                            
                      <option>25</option>
                      <option>30</option>                            
                      <option>40</option>                            
                      <option>50</option>                            
                      <option>60</option>                            
                      <option>70</option>                            
                      <option>80</option>                            
                      <option>90</option>                            
                    </select>
                </div>
                <div>
                    <b-pagination  class="ml-1" 
                      align="left"
                      :total-rows="tblLcy.total"
                      :per-page="tblLcy.limit"
                      v-model="tblLcy.page"
                    ></b-pagination>
                </div>
            </div>
          </b-col>
        </b-row>

      </b-card>

        </b-card>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe :src="reportUrl" frameborder="0"></iframe>
        </b-modal>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun" :allowHeader="true"></lku-coa>
        </b-modal>      
        <b-modal v-model="lkuDimShow" size="lg" :hide-footer="true" title="List of Dimension Value" :centered="true" >
            <lku-dim @click="onSelectedDim" :DimColName="model.DimCol" :key="model.DimCol"></lku-dim>
        </b-modal>        

    </div>
</template>

<style lang="scss" scoped>
 
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import lkuCoa from "../lookup/lkuCoa";
import lkuDim from "../lookup/lkuDim";
import buku from "../../apis/buku";
import incomestat from "../../apis/incomestat";
import myNumber from "../../components/my-number";
import toastr from "mini-toastr";
import moment from 'moment';
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
        kodeaw: { required },
        tgl1: { required },
        tgl2: { required },
        DimCol: { required },
        DimVal: { required }
    },
  }, 
  data() {
    return {
      model: {kodeaw:'',tgl1:'',tgl2:'', DimCol:'', Dimval:'', tabIndex:1},
      isLoading: false,
      reportUrl: null,
      showReport:false,
      tahun:moment(this.$store.state.user.tglaktif).format('YYYY'),
      lkuCoaShow:false,
      lkuCoaCaller:'kodeaw',
      lkuDimShow:false,
      rptLines : [],
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields:[
          {
            key: "tanggal",
            label: "Trx. Date",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
          {
            key: "nomor",
            label: "Trx. Number",
            sortable: true
          },
        {
          key: "uraian",
          label: "Description",
        },
        {
          key: "terimadari",
          label: "to/from",
          sortable: true
        },
        {
          key: "paymethod",
          label: "Pay Method",
          sortable: true
        },
        {
          key: "createby",
          label: "Create By",
          sortable: true
        },
        {
          key: "umasuk",
          label: "Debit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "ukeluar",
          label: "Credit (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "sakhir",
          label: "End Balance  (LCY)",
          thStyle: "width:140px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true
        },
        ]
      },
      filterShow:'Show',
      filter: null,
      filterInput: null,
      filterOn: [],   
    };
  },
components: { Loading, lkuCoa, lkuDim, myNumber },  
computed:{
    dimension(){
      return this.$store.state.dimension;
    },
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
watch:{
      "model.DimCol": function(newval) {
              this.model.DimVal="";
              this.model.DimValInfo="";
              const pilihan = this.dimension.find(d => d.value === newval);
              if (pilihan) {
                this.model.DimVal=pilihan.text;
                this.model.DimColInfo=pilihan.text;
              }
      },
    filterShow: function(newval) {
      setTimeout(() => {
           if (this.filterShow=='Show') {
             this.filterInput='';
             this.filter='';
            }
      }, 200);
    },
    filter: function(newval) {
      setTimeout(() => {
           if ( this.filterInput!=newval) this.filterInput=newval;
      }, 800);
    },
    
  },  

created: async function (){
    if (this.$route.params.tgl1 && this.$route.params.tgl2 && this.$route.params.kodeaw) {
        this.model.kodeaw = this.$route.params.kodeaw;
        this.model.kodeawinfo = this.$route.params.kodeaw;
        this.model.tgl1=this.$route.params.tgl1;
        this.model.tgl2=this.$route.params.tgl2;
        this.model.DimCol = this.$route.params.DimCol;
        this.model.DimVal = this.$route.params.DimVal;
        setTimeout(() => {
            this.model.DimValInfo = this.$route.params.DimVal;
        }, 500);


        this.process();
    } else {
         var tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        this.model.tgl1=`${tgl2.format('YYYY-MM')}-01`;
        this.model.tgl2=tgl2.format('YYYY-MM-DD');
        this.tahun=tgl2.format('YYYY');
    }
},
methods:{
    updateTgl1: function() {
      setTimeout(() => {
        var tgl2 = moment(this.model.tgl2, 'YYYY-MM-DD');
        if (!this.model.tgl1){
            this.model.tgl1=`${tgl2.format('YYYY-MM')}-01`;
            this.tahun=tgl2.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl1 = moment(this.model.tgl1, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.model.tgl1=`${tgl2.format('YYYY')}-01-01`;
                this.tahun=tgl2.format('YYYY');
                this.$forceUpdate();
            }
        }
        
      }, 1000);
    },
    updateTgl2: function() {
      setTimeout(() => {
        var tgl1 = moment(this.model.tgl1, 'YYYY-MM-DD');
        if (!this.model.tgl2){
            this.model.tgl2=`${tgl1.format('YYYY')}-12-31`;
            this.tahun=tgl1.format('YYYY');
            this.$forceUpdate();
        } else {
            var tgl2 = moment(this.model.tgl2, 'YYYY-MM-DD');
            if (tgl1.format('YYYY') !== tgl2.format('YYYY')){
                this.model.tgl2=`${tgl1.format('YYYY')}-12-31`;
                this.tahun=tgl1.format('YYYY');
                this.$forceUpdate();
            }
        }        
      }, 1000);
    },
    onFiltered(filteredItems) {
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
    },     
    clearFilter() {
          this.filterOn= []   
          this.filter= '';   
    } ,
    process: async function(ctx) {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        this.isLoading=true;
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');
        this.rptLines= await incomestat.detailtrx(model);      
        this.tblLcy.total = this.rptLines.length;        
        this.isLoading=false;      
       }
    },
    print: async function()
    {
        if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
            try {
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');                this.showReport=true;

                this.reportUrl= await incomestat.detailtrxprint(model);

            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    exportxls: async function() {
        if (this.invalidFilter) {
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.');
       } else {
            this.isLoading=true;
            try {
                const model = {};
                for (var key in this.model) {
                    model[key] = this.model[key];
                }
                model.tgl1= moment(this.model.tgl1).format('YYYY-MM-DD');
                model.tgl2= moment(this.model.tgl2).format('YYYY-MM-DD');
                const response = await incomestat.detailtrxexport(model);
                this.isLoading=false;    
            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
       }
    },
    confirmAction: function() {
        toastr.info('Klik Pada kolom JV.NUMBER untuk PRINT VOUCHER');
    },
    printJv: async function(data){
       if ((data.kodeacc) && (data.nomor !== 'BEGINING') && (data.nomor !== '')) {
          try {              this.showReport=true;

              this.reportUrl= await buku.printjv({ nomor: data.nomor, tanggal:moment(data.tanggal).format('YYYY-MM-DD'), kodejurnal: data.kodejurnal});

          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } 
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        if (this.lkuCoaCaller==='kodeaw'){
            this.model.kodeawinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model.kodeaw = _selected.kodeacc;
        } else {
            this.model.kodeakinfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.model.kodeak = _selected.kodeacc;
        }
        this.lkuCoaShow=false;
    },
    onSelectedDim: function(_selected){
        this.model.DimVal=_selected.kode;
        this.model.DimValInfo=`${_selected.kode.trim()} | ${_selected.nama}`;
          this.$forceUpdate();
        this.lkuDimShow=false;
    },

    close(){
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'accounting.gl')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        //   router.push("/accounting/home");
          router.push("home");
      }

    }
    
  }
};
</script>
